import React from 'react';

export default function IconAcademy() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2545_9771)">
        <path
          d="M15.3482 6.00372L8.00074 9.9548L0.65332 6.00372L8.00074 2.06396L15.3482 6.00372Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.531 7.521V11.3362C12.531 11.5853 12.4518 11.8117 12.3046 12.0155C11.8291 12.6495 10.5612 13.9401 8.00258 13.9401C5.444 13.9401 4.16471 12.6495 3.70054 12.0155C3.55337 11.823 3.47412 11.5853 3.47412 11.3362V7.521"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.8228 8.52148V10.0959"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2545_9771">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
